import { InfoOutlined } from "@mui/icons-material";
import React, { useState } from "react";
import { IToolTip } from "../../../interfaces/globalComponents/tooltip/IToolTip";
import { DefaultModal } from "../modals/material/DefaultModal";
import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { TextButton } from "../buttons/material/textButton/TextButton";
import Link from "next/link";
import { SecondaryButton } from "../buttons/material/secondaryButton/SecondaryButton";

export const ToolTip = ({ title, description }: IToolTip) => {
  const [showTooltipModal, setShowTooltipModal] = useState(false);
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors
  );

  return (
    <>
      <div
        onClick={() => setShowTooltipModal(true)}
        className="flex items-center cursor-pointer"
      >
        <InfoOutlined sx={{ color: componentColors.surface.onSurface }} />
      </div>
      <DefaultModal
        open={showTooltipModal}
        onClose={() => setShowTooltipModal(false)}
      >
        <div className="px-[16px] py-[12px] space-y-[12px] lg:max-w-[312px]">
          <div className="space-y-[4px]">
            <Typography
              className="font-semibold"
              sx={{ color: componentColors.surface.onSurfaceVariant }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                color: componentColors.surface.onSurfaceVariant,
              }}
            >
              {description}
            </Typography>
          </div>

          <Stack direction="row" className="space-x-[8px]">
            <Link href="/payment">
              <TextButton
                text="Upgrade"
                onClick={() => {
                  setShowTooltipModal(false);
                }}
                color={componentColors.primary.primary}
              />
            </Link>

            <SecondaryButton
              title="Continue"
              onClick={() => setShowTooltipModal(false)}
            />
          </Stack>
        </div>
      </DefaultModal>
    </>
  );
};
